import styled from 'styled-components';
import { media } from 'utils/style';
import Status from './Status';

export default styled(Status)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-top: 5px;

  .status-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-weight: 500;

    align-items: center;

    svg {
      height: 18px;
      width: 18px;
      margin-right: 6px;
      margin-top: -1px;
    }

    &.prepare {
      color: var(--grey700);
      svg {
        fill: var(--grey700);
      }
    }

    &.assigned {
      color: var(--grey900);
      svg {
        fill: var(--grey900);
      }
    }

    &.chill {
      color: #509c24;
      svg {
        fill: #509c24;
      }
    }

    &.warning {
      color: var(--accent900);
      svg {
        fill: var(--accent900);
      }
    }

    &.error {
      color: var(--red-cherry-text);
      svg {
        fill: var(--red-cherry-text);
      }
    }
  }

  .stops-info {
    width: 100%;
    display: flex;
    color: var(--grey900);
    grid-column: span 8;
    ${media.lessThan('extraSmall')`

    `};
  }
`;
